import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    readAllTrackingEvents,
} from '../../helpers';
import {
    trackingEventsApiResponseSuccess,
    trackingEventsApiResponseError,
} from './actions';
import { TrackingEventsActionTypes } from './constants';
import {
    trackingEventResponseToTrackingEventObject,
} from '../../helpers/mappers/trackingEvent';

export function* readAllTrackingEventsSaga({ payload: { trackingNumber } }) {
    try {
        const response = yield call(readAllTrackingEvents, trackingNumber);
        const trackingEvents = response.data.map((trackingEventResponse) =>
            trackingEventResponseToTrackingEventObject(trackingEventResponse)
        );
        yield put(trackingEventsApiResponseSuccess(TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST, trackingEvents));
    } catch (error) {
        yield put(trackingEventsApiResponseError(TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST, error));
    }
}

export function* watchReadAllTrackingEventsSaga() {
    yield takeLatest(TrackingEventsActionTypes.GET_ALL_TRACKING_EVENTS_REQUEST, readAllTrackingEventsSaga);
}

function* trackingEventsSaga() {
    yield all([
        fork(watchReadAllTrackingEventsSaga),
    ]);
}

export default trackingEventsSaga;
